import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../../SuccessModal";
import { postBrandAppService } from "../../../services/BrandAppServices";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

const AppServiceAddModal = ({
  appServiceAddModalVisible,
  setAppServiceAddModalVisible,
  sendDataToAppService,
  brandId,
  selectedAppServiceValue,
  appServiceList,
}) => {
  const OrderStatus = selectedAppServiceValue?.filter(
    (service) =>
      !appServiceList?.some((item) => item?.appService?.id === service?.id),
  );
  

  const [loadingSearch, setLoadingSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedStatus, setSelectedStatus] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleStatusToggle = (status) => {
    const updatedStatus = [status];
    setSelectedStatus(updatedStatus);
  };
  const handleDataSubmit = () => {
    const updatedData = {
      appService: {
        ...selectedStatus[0],
      },
      brandId: brandId,
    };
    postBrandAppService(brandId, updatedData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;
            setAppServiceAddModalVisible(false);
            sendDataToAppService({
              success: true,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus("success");
              setModalText(message);
            } else {
              setModalVisible(true);
              setModalStatus("not Success");
              setModalText(message);
            }
            setSelectedStatus([]);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleModalClose = () => {
    setSearchTerm("");
    setAppServiceAddModalVisible(false);
    setSelectedStatus([]);
  };

  const filterAppServiceList = () => {
    return OrderStatus?.filter((item) => {
      const Name = item.name?.toLowerCase();

      const searchedName = Name?.includes(searchTerm.toLowerCase());

      return searchedName;
    });
  };

  const filterAppServiceListData = filterAppServiceList();

  const handleClearSearch = () => {
    setSearchTerm("");
    setLoadingSearch(true);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={appServiceAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!appServiceAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-1 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                  // alignSelf: 'center',
                }}
                src={"images/plus.png"}
              />

              <p className=" text-4xl text-primary-50 font-semibold">
                ADD SERVICE
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="my-2 mx-5 flex flex-1">
                <div className="flex-1">
                  <IconField iconPosition="left" className="flex flex-1">
                    <InputIcon className="pi pi-search text-xl"> </InputIcon>
                    <InputText
                      placeholder={"Search App Service"}
                      value={searchTerm}
                      keyboardType={"default"}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="text-xl flex flex-1 py-1 px-5"
                      style={{ borderRadius: 30 }}
                    />
                  </IconField>
                </div>

                {searchTerm && (
                  <div
                    className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                    onClick={handleClearSearch}
                  >
                    <div>
                      <p
                        className="text-4xl font-bold "
                        style={{ color: "red" }}
                      >
                        X
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="mx-4">
                {filterAppServiceListData?.length > 0 ? (
                  filterAppServiceListData?.map((item) => (
                    <div
                      key={item.id}
                      className="flex flex-1 justify-content-between my-1"
                    >
                      <p className="text-xl font-medium">{item.name}</p>
                      <div>
                        <Checkbox
                          checked={selectedStatus.includes(item)}
                          size="20" // Increased size
                          color={
                            selectedStatus.includes(item)
                              ? "#00A3FF"
                              : "#C1C9D3"
                          }
                          onClick={() => handleStatusToggle(item)}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="flex justify-content-center">
                    <p className="text-xl font-medium">No Services Found</p>
                  </div>
                )}
              </div>
            </div>

            {OrderStatus?.length !== 0 && (
              <Button
                onClick={handleDataSubmit}
                className="mt-1 mb-3 mx-4 border-round-xl "
                disabled={selectedStatus?.length <= 0 && true}
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  ADD
                </p>
              </Button>
            )}
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default AppServiceAddModal;
